<template>
  <div class="upload-file">
    <p class="upload-file__title" :class="{ disabled }">
      {{ title }}
    </p>

    <p v-if="tip" class="upload-file__tip">
      {{ tip }}
    </p>

    <label
      class="upload-file__btn"
      :class="hasFileList && 'mb-20'"
      :disabled="disabled"
    >
      {{ buttonText }}

      <input
        multiple
        type="file"
        :ref="name"
        :id="name"
        class="upload-file__input"
        :disabled="disabled"
        @change="fileUpload(name)"
      >
    </label>

    <AttachedFiles
      v-if="hasFileList"
      :file-list="inputValue"
      :is-disabled="disabled"
      @delete-file="deleteFile"
      @drop-files="dropHandler"
    />
  </div>
</template>

<script>
import AttachedFiles from '@/components/page/files/AttachedFiles.vue'
import { MIXIN_DEFINE_PROP } from '@/mixins/form/input/mixinDefineProp'
import Vue from 'vue'
import { applyDrag } from '@/utils/array'

export default {
  name: 'AppInputFile',
  components: { AttachedFiles },
  inject: { formData: { from: 'formData', default: null } },
  model: {
    prop: 'value',
    event: 'value-changed'
  },
  mixins: [MIXIN_DEFINE_PROP],

  props: {
    title: String,
    tip: String,
    disabled: Boolean,
    name: String,
    value: Array,
    buttonText: {
      type: String,
      default: 'Выберите файл'
    }
  },

  computed: {
    inputValue: {
      get () {
        if (this.name && this.formData) {
          return this.formData[this.name]
        } else {
          return this.value
        }
      },
      set (val) {
        if (this.name && this.formData) {
          Vue.set(this.formData, this.name, val)
        }
        this.$emit('value-changed', val)
      }
    },

    hasFileList () {
      return this.inputValue?.length
    }
  },

  mounted () {
    if (!this.hasFileList) {
      this.inputValue = []
    }
  },

  methods: {
    fileUpload (name) {
      this.inputValue = [...this.inputValue, ...this.$refs[name].files]
      this.$refs[name].files = null
    },
    deleteFile (file, index) {
      if (file.id) {
        this.$emit('delete-file', file)
      }
      this.$delete(this.inputValue, index || file.idx)
    },
    dropHandler (result) {
      this.inputValue = applyDrag(this.inputValue, result)
    }
  }
}
</script>
